var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAroma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2E642C",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480.931 480.931",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_283_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    d: "M440.174,371.02H122.906l248.538-132.007c7.951-4.227,10.968-14.097,6.749-22.049 c-4.227-7.961-14.097-10.971-22.049-6.752L53.382,371.02H40.757C18.245,371.02,0,389.264,0,411.777s18.245,40.757,40.757,40.757 h399.417c22.511,0,40.757-18.244,40.757-40.757S462.685,371.02,440.174,371.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    d: "M300.375,193.119c2.989,1.389,5.978-1.944,4.277-4.767c-4.505-7.475-9.797-19.73-9.797-36.062 c0-22.503,25.485-32.381,25.485-64.635c0-21.397-16.309-31.695-27.287-36.204c-2.939-1.206-5.779,1.985-4.201,4.742 c3.774,6.594,8.081,17.234,8.081,31.462c0,25.314-23.631,28.633-23.631,64.635C273.301,176.349,289.252,187.953,300.375,193.119z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    d: "M418.798,193.119c2.989,1.389,5.979-1.944,4.277-4.767c-4.505-7.475-9.798-19.73-9.798-36.062 c0-22.503,25.485-32.381,25.485-64.635c0-21.397-16.309-31.695-27.287-36.204c-2.939-1.206-5.779,1.985-4.201,4.742 c3.774,6.594,8.081,17.234,8.081,31.462c0,25.314-23.631,28.633-23.631,64.635C391.725,176.349,407.675,187.953,418.798,193.119z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    d: "M361.448,170.327c2.989,1.388,5.978-1.944,4.277-4.767c-4.505-7.475-9.797-19.73-9.797-36.063 c0-22.503,25.485-32.38,25.485-64.635c0-21.397-16.308-31.695-27.287-36.203c-2.939-1.207-5.779,1.984-4.201,4.742 c3.775,6.593,8.081,17.233,8.081,31.461c0,25.313-23.631,28.633-23.631,64.635C334.374,153.556,350.325,165.16,361.448,170.327z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAroma);
export default __webpack_public_path__ + "static/media/aroma.43340909f17cf795bed0168cd48bc653.svg";
export { ForwardRef as ReactComponent };